import { MapWaysideLandLotsFilters } from "../../../../../stateManagement/reducers/maps/MapWaysideLandLotsSlice";
import { configureMapFiltersStateFromConfig } from "../filters/mapFiltersFunctions";
import { MapFiltersConfig } from "../filters/types";

export const mapFiltersConfig = [
    {
        caption: "Слои для отображения",
        type: "layer",
        format: "tree-checkbox",
        operation: "equals",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: false,
        fieldName: "LayersToShow",
        nodes: [
            {
                caption: "Земельные участки",
                children: [
                    {
                        caption: "Земельные участки",
                        value: "roadLandLot",
                        checked: true,
                    },
                    {
                        caption: 'Обособленные участки в составе ЕЗП',
                        value: 'landSubLotObject',
                        checked: true,
                    },
                    {
                        caption: 'Части земельных участков',
                        value: 'landSubLot',
                        checked: true,
                    },
                ]
            },
            {
                caption: "Смежные земельные участки",
                children: [
                    {
                        caption: 'Земельные участки',
                        value: 'adjacentLandLot',
                        checked: true,
                    },
                    {
                        caption: 'Обособленные участки в составе ЕЗП',
                        value: 'adjacentLandSubLotObject',
                        checked: true,
                    },
                    {
                        caption: 'Части земельных участков',
                        value: 'adjacentLandSubLot',
                        checked: true,
                    },
                ]
            },
            {
                caption: "Придорожные полосы",
                value: "wayside",
                checked: true,
            }
        ]
    },
    {
        caption: "Вид обременения",
        type: "value",
        format: "list-checkbox",
        operation: "includes",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: true,
        includeNull: false,
        fieldName: "EncumbranceString",
        values: [
            {
                caption: "Права третьих лиц",
                value: [1, 2, 3, 8, 11, 13],
            },
            {
                caption: "Ограничения прав на земельный участок, предусмотренные статьей 56, 56.1 Земельного кодекса Российской Федерации",
                value: 6,
            },
            {
                caption: "Запрет, арест",
                value: [4, 5],
            },
            {
                caption: "Решение об изъятии земельного участка",
                value: 7,
            },
        ],
    },
    {
        caption: "Вид права землепользования",
        type: "value",
        format: "list-checkbox",
        operation: "equals",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: true,
        includeNull: false,
        fieldName: "RightTypeId",
        values: [
            {
                caption: "Постоянное (бессрочное) пользование",
                value: 1,
            },
            {
                caption: "Хозяйственное ведение",
                value: 3,
            },
            {
                caption: "Оперативное управление",
                value: 4,
            },
            {
                caption: "Пожизненное наследуемое владение",
                value: 5,
            },
            {
                caption: "Аренда",
                value: 7,
            },
            {
                caption: "Иные права",
                value: 99,
            },
        ],
    }
] as const satisfies MapFiltersConfig;

export const initialMapFiltersState = configureMapFiltersStateFromConfig(mapFiltersConfig) as MapWaysideLandLotsFilters
export const initialActiveTabs = configureMapFiltersStateFromConfig(mapFiltersConfig)